import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dropdown, Icon, useDialog, useDateTimeFormat } from 'libs.nucleus';
import { ReportAnalyticsEvents } from '../../constants/report_analytics_events.constants';
export const ChartHeader = ({ chart, lastRefreshed, chartQueryFilters, chartPresetFilters, setChartFilterModal, handleExport, isLoading, isExporting, logReportEvent, }) => {
    const dialog = useDialog();
    const { formatDateTime: formatLastRefreshed } = useDateTimeFormat();
    const handleShowInfoCard = async (cardInfo) => {
        logReportEvent?.(ReportAnalyticsEvents.INFO_CARD_OPENED, {
            chart_id: chart.id,
            chart_title: chart.title,
        });
        await dialog.open({
            title: 'Information card',
            body: _jsx("div", { className: 'max-h-[500px] overflow-auto', dangerouslySetInnerHTML: { __html: cardInfo } }),
            actionButtons: [{ label: 'Close' }],
        });
    };
    return (_jsxs("div", { className: 'flex flex-1 items-center justify-between px-2', children: [_jsx("div", { children: chart.title || chart.name }), _jsxs("div", { className: 'flex items-center space-x-1', children: [chart.filter && (_jsxs("div", { className: 'relative', children: [(Object.keys(chartQueryFilters[chart.id] || {}).length > 0 ||
                                chartPresetFilters[chart.id]?.length > 0) && (_jsx("span", { className: 'absolute top-0 right-0 -mt-1 -mr-1 bg-primary-500 text-white nucleus-font-medium nucleus-text-xs flex justify-center items-center nucleus-rounded-full size-5', children: Object.entries(chartQueryFilters[chart.id] || {}).reduce((acc, [, value]) => acc + value.length, 0) + (chartPresetFilters[chart.id]?.length || 0) })), _jsx(Button, { label: 'Filter', variant: 'transparent', content: _jsx(Icon, { name: 'filter' }), onClick: () => {
                                    setChartFilterModal({
                                        id: chart.id,
                                        isOpen: true,
                                        filterType: chart?.filter?.type,
                                        filterData: chart.filter,
                                    });
                                } })] })), _jsx(Dropdown, { variant: 'kebab', position: 'bottom-end', items: [
                            {
                                id: 'last-refresh-' + chart.id,
                                content: `Last refreshed: ${formatLastRefreshed(lastRefreshed)}`,
                                onClick: () => { },
                                disabled: true,
                            },
                            {
                                id: 'info-' + chart.id,
                                content: 'See info card',
                                hidden: !chart.cardInfo,
                                onClick: () => handleShowInfoCard(chart.cardInfo),
                            },
                            {
                                id: 'export-' + chart.id,
                                content: isExporting ? 'Exporting...' : 'Export',
                                onClick: handleExport,
                                disabled: isLoading || isExporting,
                                hidden: !handleExport,
                            },
                        ] })] })] }));
};
